import { api } from '../utils/api';

export interface Promotion {
  id: number;
  name: string;
  type: 'HAPPY_HOUR' | 'PERCENTAGE_DISCOUNT' | 'FIXED_DISCOUNT';
  discount_percentage: number;
  discount_amount: number;
  days_of_week?: number[] | null;
  start_time?: string | null;
  end_time?: string | null;
  category_id?: number | null;
  product_id?: number | null;
  is_active: boolean;
  category?: { id: number; name: string };
  product?: { id: number; name: string; price: number };
}

export async function getPromotions(): Promise<Promotion[]> {
  const { data } = await api.get<Promotion[]>('/promotions');
  return data;
}

export async function getActivePromotions(): Promise<{ count: number; promotions: Promotion[] }> {
  const { data } = await api.get<{ count: number; promotions: Promotion[] }>('/promotions/active');
  return data;
}

export async function createPromotion(payload: Partial<Promotion>): Promise<Promotion> {
  const { data } = await api.post<Promotion>('/promotions', payload);
  return data;
}

export async function updatePromotion(id: number, payload: Partial<Promotion>): Promise<Promotion> {
  const { data } = await api.put<Promotion>(`/promotions/${id}`, payload);
  return data;
}

export async function togglePromotion(id: number): Promise<{ message: string; promotion: Promotion }> {
  const { data } = await api.patch<{ message: string; promotion: Promotion }>(`/promotions/${id}/toggle`);
  return data;
}

export async function deletePromotion(id: number): Promise<void> {
  await api.delete(`/promotions/${id}`);
}
